module.exports = __webpack_public_path__ + "static/media/pointBadgeLevel5Locked.4e61d5bf.png";